/**
 * BM-H4986 (Vanessa, 2 Nov 2026): "please ensure anyone can register pre-CM
 * matters". A role whose card sections include "pre_cm" but not "compliance"
 * (post scanning) still gets the Pre-CaseMinder card on its own.
 */
export function requestSectionsFor(sections, visible) {
  return sections
    .map((sec) => {
      if (visible.includes(sec.key)) return sec;
      if (sec.key === "compliance" && visible.includes("pre_cm")) {
        return { ...sec, cards: sec.cards.filter((c) => c.href === "/pre-caseminder") };
      }
      return null;
    })
    .filter(Boolean);
}
